module.exports = __webpack_public_path__ + "static/media/apple.e09ccec7.jpg";